import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ILineConfirmationWarningProps {
  text: string;
  buttons?: any;
}

export const LineConfirmationWarning = (props: ILineConfirmationWarningProps) => {
  return (
    <div className="warning">
      <div className="icon">
        <FontAwesomeIcon icon="exclamation-triangle" />
      </div>

      <div className="text">{props.text}</div>

      {props.buttons ? props.buttons : null}

      <style jsx>{`
        .warning {
          height: 50px;
          display: flex;
          align-items: center;
          border: solid 1px #e6e6e6;
          color: black;
          font-size: 13px;
          border-left: solid 2px #f8bb06;
          animation: openWarning 200ms;
          transform-origin: top center;
          margin: 10px 0;
          padding-right: 12px;
          border-radius: 2px;
          background: white;
          width: 100%;
        }

        .warning .icon {
          color: #f8bb06;
          margin: 0 12px;
        }

        .warning .icon {
          color: #f8bb06;
          margin: 0 12px;
        }

        .warning .text {
          flex: 1;
          line-height: 18px;
        }

        @keyframes openWarning {
          from {
            opacity: 0.6;
            transform: scaleY(0.5);
          }
          to {
            opacity: 1;
            transform: scaleY(1);
          }
        }
      `}</style>
    </div>
  );
};

interface IConfirmationButtonProps {
  text?: string;
  children?: any;
  onClick: () => void;
}

export const ConfirmationButton = (props: IConfirmationButtonProps) => (
  <div className="button" onClick={props.onClick}>
    {props.text || props.children}
    <style jsx>{`
      .button {
        color: #000;
        margin: 0 6px;
        cursor: pointer;
        opacity: 0.7;
        transition: all 200ms;
      }

      .button:hover {
        opacity: 1;
      }
    `}</style>
  </div>
);
